module.exports = __webpack_public_path__ + "static/img/yw03.d42e95f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/yw03.png
// module id = x4vp
// module chunks = 0